module.exports = __webpack_public_path__ + "static/media/documentacion.a4ce26b5.png";